export const restrictedENWords = [
  'sex',
  'prostitution',
  'cunt',
  'penis',
  'pussy',
  'nipples',
  'boobs',
  'cocain',
  'drug',
  'pervitin',
  'crystal',
  'marihuana',
  'ass',
  'dick',
  'arse',
  'ass',
  'asshole',
  'bastard',
  'bitch',
  'bollocks',
  'bugger',
  'child-fucker',
  'crap',
  'cunt',
  'damn',
  'effing',
  'frigger',
  'fuck',
  'goddamn',
  'godsdamn',
  'hell',
  'holy shit',
  'horseshit',
  'motherfucker',
  'nigga',
  'prick',
  'shit',
  'shit ass',
  'shitass',
  'slut',
  'son of a bitch',
  'son of a whore',
  'sweet Jesus',
  'twat',
];

export const restrictedCZWords = [
  'sex',
  'prostituce',
  'kunda',
  'penis',
  'píča',
  'pica',
  'bradavky',
  'prsa',
  'kokain',
  'drogy',
  'léky',
  'leky',
  'pervitin',
  'marihuana',
  'marjánka',
  'marjanka',
  'prdel',
  'čůza',
  'cuza',
  'mrdka',
  'čůrák',
  'curak',
  'pamrd',
  'mrdat',
  'prcat',
  'šukat',
  'sukat',
  'šoustat',
  'soustat',
  'kurva',
  'děvka',
  'devka',
];

export const restrictedITWords = [
  'vagina',
  'pene',
  'culo',
  'trombare',
  'seni',
  'seno',
  'stronzo',
  'prostituzione',
  'marijuana',
  'figa',
  'fica',
  'cocaina',
  'dildo',
  'tette',
  'metanfetamina',
  'droghe',
  'narcotico',
  'narcotraffico',
  'capezzolo',
  'merda',
  'cazzo',
  'minchia',
  'pisello',
  'pisellino',
  'pisellone',
  'cazzone',
  'chiappe',
  'mignotta',
  'puttana',
  'troia',
  'battona',
  'vacca',
  'culona',
  'merda',
  'seno',
  'seni',
  'stronzo',
  'ricchione',
  'culatone',
  'figlio di troia',
  'figlio di puttana',
  'pezzo di merda',
  'vaffanculo',
  'gay',
  'scopare',
  'fottere',
  'trombare',
  'prostitute',
  'prostituta',
];

export const fnCheckForRestrictedWords = (word: string) => {
  const txtInput = word;
  let error = 0;
  let newTxt: string;
  if (txtInput) {
    newTxt = word;
    console.log(newTxt.toLowerCase());
    if (
      restrictedITWords.some(v => newTxt.toLowerCase() === v) ||
      restrictedENWords.some(v => newTxt.toLowerCase() === v) ||
      restrictedCZWords.some(v => newTxt.toLowerCase() === v)
    ) {
      error = error + 1;
    }
  }

  if (error > 0) {
    return true;
  }
};
